import { IconButton, Table, TableBody, TableCell, TableHead, TableRow, Tooltip, Typography } from "@mui/material";
import { Announcements } from "../../Types/UnitFeatureTypes";
import { maxCardList } from "../../Utils/Constants";
import { OpenInNew } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import BuildAnnouncementTable from "../BuildTables/BuildAnnouncementTable";

const DisplayAnnouncementCard: React.FC<{ item: Announcements[] }> = ({ item }) => {

    const navigate = useNavigate();
    const handleAnnouncementExpand = (id: number) => {
        navigate(`/viewAnnouncement`, { state: { id: id } });
    }

    return (
       <BuildAnnouncementTable item={item} />
    )
}

export default DisplayAnnouncementCard;